export default __webpack_public_path__ + "static/media/contact.5d93e344.PNG";